import React from 'react';
import { array, func, object } from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import { getInvoiceLoveCodeList } from '@dragonfruit/redux/profile';

import OutlineSelect from '@dragonfruit/components/fields/OutlineSelect';

function Donation({ initialValues, t, onFieldChange, loveCodeList, errors }) {
  const { loveCode } = initialValues;

  return (
    <OutlineSelect
      floatingLabelText={t('purchase.tweinvoice.donate.title')}
      placeholder={t('purchase.tweinvoice.donate.placeholder')}
      value={loveCode}
      options={loveCodeList}
      onChange={({ value }) => onFieldChange('loveCode', value)}
      openOnClick
      searchable={false}
      clearable={false}
      error={errors.loveCode}
    />
  );
}

Donation.propTypes = {
  errors: object.isRequired,
  initialValues: object.isRequired,
  loveCodeList: array.isRequired,
  t: func.isRequired,
  onFieldChange: func.isRequired,
};

export default translate(['purchase'])(
  connect(state => ({
    loveCodeList: getInvoiceLoveCodeList(state),
  }))(Donation)
);



// WEBPACK FOOTER //
// ./app/components/EInvoiceSelector/components/Donation/Donation.jsx